import { useNavigate } from 'react-router-dom';
import { Zap } from 'lucide-react';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-950">
      <div className="text-center">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-zinc-800">
          <Zap className="h-8 w-8 text-zinc-600" />
        </div>
        <h1 className="text-4xl font-bold text-white">404</h1>
        <p className="mt-2 text-sm text-zinc-400">Page not found</p>
        <button
          onClick={() => navigate('/')}
          className="mt-6 rounded-lg bg-[#F78C4E] px-6 py-2.5 text-sm font-medium text-white transition-colors hover:bg-[#E67A3C]"
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
}
